import { Component, computed, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { DatePickerModule } from '@openng/optimus-ui/datepicker';
import { InputNumberModule } from '@openng/optimus-ui/inputnumber';
import { SelectModule } from '@openng/optimus-ui/select';
import { TableModule } from '@openng/optimus-ui/table';
import { rxResourceFixed, DropdownData, CurrencyService } from '@zayan-erp/shared';
import { DsmDepositService } from '../../services/dsm-deposit.service';
import { DsmImportDeposit } from '../../models/dsm-deposit.models';

@Component({
  selector: 'dsm-aps-deposits-imports',
  standalone: true,
  imports: [FormsModule, TableModule, DatePickerModule, InputNumberModule, SelectModule],
  templateUrl: './dsm-aps-deposits-imports.component.html'
})
export class DsmApsDepositsImportsComponent {
  importType = input<string>();
  selectedLot = output<string>();

  #depositService = inject(DsmDepositService);
  #currencyService = inject(CurrencyService);

  readonly currencyCode = this.#currencyService.currencyCode;

  depositTypes = toSignal(this.#depositService.getDepositTypes(), { initialValue: [] as DropdownData[] });

  lots = computed(() => this.getLots.value() ?? []);

  getLots = rxResourceFixed({
    params: () => ({ dealId: this.#depositService.dealId() ?? '' }),
    defaultValue: [],
    stream: ({ params }) => {
      if (!params.dealId) {
        return of([]);
      }
      return this.#depositService.dealsByDealId(params.dealId);
    }
  });

  importDeposits = computed(() => this.#depositService.deposits());

  onLotSelected(lotId: string | null | undefined): void {
    this.selectedLot.emit(lotId ? String(lotId) : '');
  }

  onDateChange(index: number, date: Date | null): void {
    const deposits = this.#depositService.deposits();
    if (deposits[index]) {
      (deposits[index] as DsmImportDeposit).depositDueDate = date?.toISOString() ?? '';
      this.#depositService.deposits.set([...deposits]);
    }
  }

  onAmountChange(index: number, amount: number | null): void {
    const deposits = this.#depositService.deposits();
    if (deposits[index]) {
      deposits[index].depositAmount = amount ?? 0;
      this.#depositService.deposits.set([...deposits]);
    }
  }

  getDepositTypeName(depositTypeId: string | undefined): string {
    if (!depositTypeId) return '';
    const depositType = this.depositTypes().find(type => type.id === depositTypeId);
    return depositType?.firstLabel ?? '';
  }
}
